import toastr from 'toastr';
import {notify} from 'linksoft';

// defaults
if(typeof toastr.options === 'object') {
    toastr.options.positionClass = 'toast-bottom-right';
    notify.options = toastr.options;
}

notify.implementation(function (type, message, title, options) {
    if(message || title) {
        toastr[type](message, title, options);
    }
});


// WEBPACK FOOTER //
// ./node_modules/linksoft-toastr/src/index.js